import { useIntl } from 'react-intl';
import useAuth from 'src/hooks/useAuth';
import Content from 'src/componentes/pages/content';
import List from 'src/componentes/list';
import ListColumn from 'src/componentes/list/list-column';
import { capitalizeFirstLetter } from 'src/utils/string';
import { COLUNAS, FILTROS } from 'src/utils/constants';

import SearchSchema from './SearchSchema';
import Search from './Search';

const AlocacaoRecursosList = ({ filtroURL, projetoId }) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();

  const ehFiltroURL = filtroURL && Object.keys(filtroURL).length > 0;

  let selectedFilter = null;

  if (ehFiltroURL) {
    selectedFilter = {
      valor: {
        colaborador:
          filtroURL.colaboradorId && filtroURL.colaboradorId != '-1'
            ? {
                id: filtroURL.colaboradorId,
                nome: filtroURL.colaboradorNome,
              }
            : null,
        recurso:
          filtroURL.recursoId && filtroURL.recursoId != '-1'
            ? { id: filtroURL.recursoId, nome: filtroURL.recursoNome }
            : null,
        dataInicio: filtroURL.dataInicio
          ? new Date(Number(filtroURL.dataInicio))
          : null,
        dataTermino: filtroURL.dataTermino
          ? new Date(Number(filtroURL.dataTermino))
          : null,
      },
    };
  } else if (projetoId) {
    selectedFilter = {
      valor: {
        projeto: { id: projetoId },
      },
    };
  }

  const usarFiltroSalvo = !ehFiltroURL && !projetoId;

  return (
    <Content>
      <List
        sort="Acao.Ultimaversao.Descricao"
        url="/AlocacaoRecursos"
        createChildItems={[]}
        showSearch={!projetoId}
        hideFiltroChip={projetoId}
        searchSchema={SearchSchema}
        searchComponent={<Search />}
        filtroId={FILTROS.LISTAALOCACAORECURSOS}
        forceSelectedFilter={!usarFiltroSalvo}
        tag={COLUNAS.LISTAALOCACAORECURSOS}
        showTitle={false}
        showNew={false}
        showMenu={false}
        showEdit={false}
        showDelete={false}
        showExport={true}
        hideSendEmail={true}
        hideSearchText={true}
        usarFiltroSalvo={usarFiltroSalvo}
        openLastFilter={usarFiltroSalvo}
        selectedFilter={selectedFilter}
        filterDrawer
      >
        <ListColumn
          headerText={capitalizeFirstLetter(
            intl.formatMessage({ id: 'recurso' })
          )}
          valueField="nome"
          default
          required
        />
        <ListColumn
          headerText={capitalizeFirstLetter(resources.projeto)}
          valueField="projeto"
          default
        />
        <ListColumn
          headerText={capitalizeFirstLetter(resources.acao)}
          required
          valueField="acao"
          default
        />
        <ListColumn
          headerText={intl.formatMessage({ id: 'periodo' })}
          valueField="periodoAcao"
          default
        />
        <ListColumn
          headerText={intl.formatMessage({ id: 'label.horas' })}
          valueField="horas"
          default
        />
        <ListColumn
          headerText={intl.formatMessage({ id: 'percentualAlocacao' })}
          valueField="percentual"
          default
        />
        <ListColumn
          headerText={intl.formatMessage({ id: 'superAlocacao' })}
          valueField="superAlocacao"
          default
        />
      </List>
    </Content>
  );
};

export default AlocacaoRecursosList;
